export const strings = {
  title: 'Report a Bug',
  description: 'Tell us what went wrong so we can address it.',
  descriptionWithHelpCenter:
    'Use this to quickly report issues that do not require a reply. If you need a response, please contact Support through the',
  placeHolder: 'Describe the issue',
  primaryText: 'Submit Report',
  secondaryText: 'Cancel',
  connectionIssueTextBefore: 'Having connection issues? Try ',
  connectionIssueTextLink: 'refreshing your status',
  connectionIssueTextAfter: '  first.',
  resetAccountTextLink: 'resetting your account',
} as const;
